
import { computed, defineComponent, PropType } from 'vue'
import { isExternal } from '@/utils/validate'
import { RouteLocationRaw } from 'vue-router'

export default defineComponent({
  name: 'AppLink',
  props: {
    to: {
      type: [String, Object] as PropType<string | RouteLocationRaw>,
      required: true
    }
  },
  setup(props) {
    // 检查是否为外部链接
    const isExternalLink = computed(() => {
      if (typeof props.to === 'object' && props.to !== null) {
        // 如果to是对象且有meta.link属性，检查meta.link是否为外部链接
        const toObj = props.to as any
        if (toObj.meta && toObj.meta.link && typeof toObj.meta.link === 'string') {
          return isExternal(toObj.meta.link)
        }
      }
      return typeof props.to === 'string' && isExternal(props.to)
    })
    
    const type = computed(() => {
      if (isExternalLink.value) {
        return 'a'
      }
      return 'router-link'
    })
    
    const linkProps = (to: string | RouteLocationRaw) => {
      if (isExternalLink.value) {
        // 如果是对象且有meta.link属性，使用meta.link作为href
        if (typeof to === 'object' && to !== null) {
          const toObj = to as any
          if (toObj.meta && toObj.meta.link) {
            return {
              href: toObj.meta.link,
              target: '_blank',
              rel: 'noopener'
            }
          }
        }
        return {
          href: to,
          target: '_blank',
          rel: 'noopener'
        }
      }
      return {
        to: to
      }
    }
    
    return {
      type,
      linkProps
    }
  }
})
